import React from 'react';
import { connect } from 'react-redux';
import { requestExternalUploader } from '@ff-os/pdp-shared-redux/apis/external-upload/requestExternalUploader';
import { ExternalUploadStatus, selectExternalUploadStatus } from '@ff-os/pdp-shared-redux/slices/externalUploadersSlice';
import { DeviceUpload } from '@ff-os/shared-react/components/upload-methods/partials/DeviceUpload';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsExternalUploader } from '@ff-scene-plugins/photo-prints-redux/types/PhotoPrintsExternalUploader';
import { selectExternalUploaderByGroupId } from '../_redux-external-uploaders';

const _PhotoPrintsDeviceUpload = ({
    createExternalUploader,
    externalUploader,
    status,
    onChange
}: Props) => {
    return (
        <DeviceUpload
            onChange={onChange}
            status={status}
            imageCount={externalUploader?.imageCount ?? 0}
            externalUploader={externalUploader}
            createExternalUploader={createExternalUploader} />
    );
};

type Props = OwnProps & {
    status: ExternalUploadStatus;
    externalUploader?: PhotoPrintsExternalUploader;
    createExternalUploader: () => void;
};

type OwnProps = {
    groupId: string;
    multiple: boolean;
    accept: string;
    maxSize: number;
    onChange: () => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    externalUploader: selectExternalUploaderByGroupId(state, ownProps.groupId),
    status: selectExternalUploadStatus(state)
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    createExternalUploader: () => dispatch(requestExternalUploader({
        payload: {
            groupId: ownProps.groupId
        },
        accept: ownProps.accept,
        allowMultipleFiles: ownProps.multiple,
        maxFileSize: ownProps.maxSize
    }))
});

export const PhotoPrintsDeviceUpload = connect(
    mapStateToProps, mapDispatchToProps)
(_PhotoPrintsDeviceUpload);